import { getAuth } from "firebase/auth";

const API_BASE = process.env.REACT_APP_apiHostLink;

const getIdToken = async () => {
  const user = getAuth().currentUser;
  if (!user) throw new Error("Not authenticated");
  return user.getIdToken();
};

const request = async (method, path, body = null) => {
  const token = await getIdToken();
  const options = {
    method,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  if (body) options.body = JSON.stringify(body);

  const res = await fetch(`${API_BASE}/api/admin${path}`, options);
  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.message || `Request failed with status ${res.status}`);
  }
  return data;
};

const adminApi = {
  getDashboardStats: () => request("GET", "/dashboard/stats"),

  listPublicDonors: (params) =>
    request("GET", `/public-donors?${new URLSearchParams(params)}`),
  getPublicDonor: (id) => request("GET", `/public-donors/${id}`),
  updatePublicDonor: (id, body) => request("PUT", `/public-donors/${id}`, body),
  deletePublicDonor: (id) => request("DELETE", `/public-donors/${id}`),

  listDonors: (params) =>
    request("GET", `/donors?${new URLSearchParams(params)}`),
  getDonor: (id) => request("GET", `/donors/${id}`),
  updateDonor: (id, body) => request("PUT", `/donors/${id}`, body),
  updateDonorStatus: (id, status) =>
    request("PATCH", `/donors/${id}/status`, { status }),

  listBloodRequests: (params) =>
    request("GET", `/blood-requests?${new URLSearchParams(params)}`),
  getBloodRequest: (id) => request("GET", `/blood-requests/${id}`),
  updateBloodRequest: (id, body) =>
    request("PUT", `/blood-requests/${id}`, body),
  deleteBloodRequest: (id) => request("DELETE", `/blood-requests/${id}`),

  // Demand Analytics
  getAnalyticsOverview: (days = 30) => request("GET", `/analytics/overview?days=${days}`),
  getBloodDemand: (days = 90) => request("GET", `/analytics/blood-demand?days=${days}`),
  getLocationAnalytics: (days = 90) => request("GET", `/analytics/areas?days=${days}`),
  getTimeAnalytics: (days = 90) => request("GET", `/analytics/time?days=${days}`),
  getUserActivity: (days = 30) => request("GET", `/analytics/user-activity?days=${days}`),

  // Predictions
  getBloodDemandPredictions: () => request("GET", "/predictions/blood-demand"),
  getAreaPredictions: () => request("GET", "/predictions/areas"),
  getPredictionSummary: () => request("GET", "/predictions/summary"),

  // Settings
  getSettings: () => request("GET", "/settings"),
  updateSetting: (key, value) => request("PUT", "/settings", { key, value }),

  // AI Service
  getAiProviders: () => request("GET", "/ai/providers"),
  testAiConnection: (body) => request("POST", "/ai/test-connection", body),
  getAiUsageStats: () => request("GET", "/ai/usage-stats"),
};

export default adminApi;
